import React from "react";

/**
 * Balk die onderaan blijft plakken zolang er onopgeslagen wijzigingen zijn.
 * Links staat wát er is gewijzigd, rechts annuleren/opslaan.
 *
 * De positionering zit in `.purchase-action-bar` in globals.css en niet hier,
 * omdat hij twee paddings moet wegrekenen die buiten deze component liggen: die
 * van `.app-content` (de scrollcontainer, 25px boven 768px) en die van de pagina
 * zelf. Zonder dat zweefde de balk 49px boven de footer. Zie de toelichting bij
 * die CSS-regel.
 *
 * `pagePadding` moet gelijk zijn aan de padding van de pagina-wrapper; beide
 * inkoop-detailpagina's gebruiken 24.
 */
const StickyActionBar = ({ note, children, pagePadding = 24 }) => (
  <div className="purchase-action-bar" style={{ "--purchase-page-pad": `${pagePadding}px` }}>
    <span style={{ fontSize: 13, color: "rgba(0, 0, 0, 0.55)", minWidth: 0, flex: "1 1 auto" }}>{note}</span>
    <div style={{ display: "flex", gap: 8, alignItems: "center", flex: "none" }}>{children}</div>
  </div>
);

export default StickyActionBar;
